import { useEffect, useRef } from 'react';

// Use useEffect to measure the tallest element's height
export const useTallestListItemHeight = () => {
  const elementRefs = useRef<Array<Array<any>>>([]);

  useEffect(() => {
    let resizeTimer: ReturnType<typeof setTimeout>;

    const calculateHeights = () => {
      elementRefs?.current?.forEach(elementRowRef => {
        // enter the row of list items

        elementRowRef?.forEach(elementListRef => {
          // find the highest item in each item of the list
          let maxHeight = 0;

          elementListRef?.forEach(listItemRef => {
            // remove all the previously assigned heights
            listItemRef?.style.removeProperty('height');
            const { height } = listItemRef.getBoundingClientRect();
            maxHeight = Math.max(maxHeight, height);
          });

          elementListRef?.forEach(listItemRef => {
            // assign the new height to all the items in the list
            listItemRef?.style.setProperty('height', `${maxHeight}px`);
          });
        });
      });
    };

    // this replaces the initilisation of the tallestElementHeight
    // so that it is not set to 0px before the DOM renders
    requestAnimationFrame(() => {
      setTimeout(() => {
        calculateHeights();
      }, 0);
    });

    const handleResize = () => {
      // Clear the existing timer
      clearTimeout(resizeTimer);

      // Set a new timeout to call calculateMaxHeight after a short delay
      resizeTimer = setTimeout(calculateHeights, 100);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [elementRefs]);

  return { elementRefs };
};
